export default {
  general: {
    filters: "Filtry",
    save: "Zapisz",
    cancel: "Anuluj",
    add: "Dodaj",
    create: "Utwórz",
    update: "Aktualizuj",
    download: "Pobierz",
    attachedFile: "Załączony plik",
    yes: "Tak",
    no: "Nie",
  },
  badges: {
    active: "Aktywny",
    notActive: "Nieaktywny",
    subscription: "Subskrypcja",
    once: "Płatność jednorazowa",
  },
  order: {
    setOrder: "Ustal kolejność",
  },
  routes: {
    reports: {
      main: "Raporty",
      dashboard: "Raporty",
      show: "Raport",
    },
    rpg: {
      main: "RPG",
    },
    questionOfDay: {
      main: "Pytanie dnia",
      list: "Lista serii",
      review: "Review pytań",
    },
    hero: {
      main: "Hero",
      form: "Dodaj",
      list: "Ustawienia slidera",
      noSerie: "- brak powiązanej serii -",
      edit: "Edytuj",
      delete: "Usuń",
      description: "Opis",
      description2: "Opis 2",
      location: "Link (jeśli ma być inny, niż domyślny)",
      description_link: "Opis linku (jeśli ma być inny, niż domyślny)",
      title: "Tytuł",
      link: "Link",
      type: "Typ",
      language: "Język",
      serie: "Serial",
      serieAi: "Serial (Szkoła AI)",
      aiSchool: "Szkoła AI",
      image: "Grafika (web)",
      imageMobile: "Grafika (mobile)",
      active: "Aktywny",
      ceo: "CEO (nowy interfejs)",
      save: "Zapisz",
      send: "Dodaj",
    },
    livesessions: {
      main: "Sesja live",
    },
    assessmentmodule: {
      form: "Dodaj Assessment do modułu",
    },
    sections: {
      list: "Sekcje",
    },
    groups: {
      list: "Grupy",
      main: "Grupy",
      form: "Dodaj",
    },
    homeworks: {
      list: "Prace domowe",
    },
    schedules: {
      list: "Daty odblokowań modułów",
    },
    materials: {
      list: "Lista materiałów",
      form: "Dodaj materiał",
    },
    assessmentsmodule: {
      list: "Lista przypisanych assessmentów",
    },
    widgets: {
      list: "Spotkania online",
    },
    kickoffs: {
      list: "Kickoffs",
    },
    modules: {
      list: "Moduły",
    },
    preworks: {
      list: "Preworki",
    },
    assessments: {
      list: "Assessmenty",
    },
    reflections: {
      form: "Refleksja",
      list: "Refleksje",
    },
    login: {
      main: "Logowanie",
    },
    users: {
      main: "Użytkownicy",
      list: "Lista użytkowników",
      form: "Dodaj użytkowników",
      reports: "Raporty",
      generator: "Generator haseł",
      edit: "Edytuj użytkownika",
    },
    announcements: {
      main: "Zapowiedzi",
      list: "Lista zapowiedzi",
      form: "Dodaj zapowiedź",
      edit: "Edytuj zapowiedź",
    },
    companies: {
      main: "Firmy",
      list: "Lista firm",
      form: "Dodaj firmę",
    },
    employees: {
      list: "Pracownicy",
      form: "Dodaj pracowników do tej firmy",
    },
    paths: {
      main: "Ścieżki",
      list: "Lista ścieżek",
      add: "Dodaj ścieżkę",
      edit: "Edytuj ścieżkę",
    },
    notifications: {
      main: "Push",
      form: "Powiadomienia push",
    },
    exams: {
      main: "Egzaminy",
      list: "Lista egzaminów",
      form: "Dodaj egzamin",
      results: "Wyniki egzaminów",
    },
    quizzes: {
      main: "Quizy",
      list: "Lista quizów",
      form: "Dodaj quiz",
    },
    boardmeetingChallengeLiveSessions: {
      main: "Boardmeeting Live",
      list: "Lista live sessions",
      form: "Dodaj live session",
    },
    vouchers: {
      main: "Vouchery",
      list: "Lista voucherów",
      form: "Dodaj voucher",
    },
    videos: {
      main: "Filmy",
      list: "Lista filmów",
      form: "Dodaj video",
      edit: "Edytuj video",
    },
    series: {
      main: "Serie",
      list: "Lista serii",
      form: "Dodaj serię",
      edit: "Edytuj serię",
    },
    categories: {
      main: "Kategorie",
      list: "Lista kategorii",
      form: "Dodaj kategorię",
      order: "Ustal kolejność",
    },
    points: {
      main: "Punkty",
      list: "Zarządzanie punktami",
      history: "Historia",
    },
    authors: {
      main: "Autorzy",
      list: "Lista autorów",
      form: "Dodaj autora",
      edit: "Edytuj autora",
    },
    settings: {
      main: "Ustawienia",
      hero: "Hero",
      searcher: "Wyszukiwarka",
      slider: "Slider",
    },
    accredible: {
      main: "Accredible",
      list: "Lista accredible",
      form: "Dodaj accredible",
      generate: "Generuj certyfikat",
    },
    cohort: {
      main: "Kohorta",
      list: "Lista modułów",
      addModule: "Dodaj nowy moduł",
      addMaterial: "Dodaj nowy materiał",
      editModule: "Edytuj moduł",
      editMaterial: "Edytuj materiał",
    },
    wall: {
      main: "Wall",
      list: "Ustawienia walla",
      addModule: "Dodaj nowy moduł",
      editModule: "Edytuj moduł",
      form: "Dodaj moduł",
    },
    materialZone: {
      main: "Strefa materiałów",
      elements: "Lista materiałów",
      addElement: "Dodaj materiał",
      editElement: "Edytuj materiał",
      slides: "Lista slajdów",
      addSlide: "Dodaj slajd",
      editSlide: "Edytuj slajd",
      boardmeetingMaterials: "Materiały boardmeetings",
      addBoardmeetingMaterial: "Dodaj materiał boardmeetings",
      editBoardmeetingMaterial: "Edytuj materiał boardmeetings",
    },
    programs: {
      main: "Programy",
      list: "Lista programów",
      addProgram: "Dodaj program",
      form: "Dodawanie programu",
      addSection: "Dodaj sekcję",
      addModule: "Dodaj moduł",
      addUser: "Dodaj uczestnika",
      addHomework: "Dodaj prace domową",
      addprework: "Dodaj prework",
      addGroup: "Dodaj grupę",
      addassessment: "Dodaj assessment",
      addLiveWebinar: "Dodaj spotkanie online",
      addPrecertificate: "Dodaj",
      addSchedule: "Dodaj date odblokowania modułu",
      addReflection: "Dodaj refleksję",
      addTemplate: "Dodaj szablon tablicy",
      addKickoff: "Dodaj kickoff",
      section: {
        form: "Sekcja",
      },
      module: {
        form: "Moduł",
      },
      groups: {
        form: "Grupa",
      },
      assessments: {
        categories: "Kategorie",
        questions: "Pytania",
      },
    },
    precertificates: {
      main: "Precertyfikacja",
      list: "Precertyfikacja",
      form: "Dodaj",
    },
    squad: {
      main: "Squad",
      list: "Lista squadów",
      form: "Dodaj squad",
      add: "Dodaj squad",
      edit: "Edytuj squad",
    },
    ceoTeams: {
      main: "Zespoły CEO",
      list: "Lista zespółów CEO",
      form: "Dodaj zespół CEO",
    },
    ceoLivewebinars: {
      main: "CEO nagrania live",
      list: "CEO nagrania live",
      form: "Dodaj nagranie live",
    },
    ceoWorkshops: {
      main: "CEO warsztaty",
      list: "CEO warsztaty",
      form: "Dodaj warsztat",
    },
    aiSchool: {
      main: "Szkoła praktyków AI",
      list: "Szkoła praktyków AI",
    },
  },
  options: {
    accredible: {
      placeholder: "Accredible",
      search: "Wyszukaj accredible",
    },
    authors: {
      placeholder: "Autor",
      search: "Wyszukaj autora",
    },
    company: {
      placeholder: "Firma",
      search: "Wyszukaj firmę",
    },
    series: {
      placeholder: "Seria",
      search: "Wyszukaj serię",
    },
    materialZone: {
      placeholder: "Materiał",
      search: "Wyszukaj materiał",
    },
  },
  languages: {
    what: {
      pl: "polski",
      en: "angielski",
      ae: "arabski",
    },
  },
  auth: {
    logout: "Wyloguj się",
  },
  optional: "opcjonalnie",
  choose: "Wybierz",
  acceptDelete: "Na pewno chcesz usunąć?",
  publication: "Publikacja",
  areYouSure: "Na pewno chcesz",
  cancelPublication: "anulować publikację",
  publish: "opublikować",
  confirmDraft: "Zatwierdź wersję roboczą",
  toConfirmDraft: "zatwierdzić wersję roboczą",
  show: "Pokaż",
  dp_programs: {
    main: "Programy rozwojowe",
    list: "Lista programów",
  },
};
